import React, { useState } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import {
  FiUsers, FiShield, FiKey, FiSettings,
  FiFileText, FiShoppingCart, FiMail, FiSliders,
  FiArrowLeft
} from 'react-icons/fi';

const Admin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(getActiveTabFromPath());

  function getActiveTabFromPath() {
    const path = location.pathname;
    if (path.includes('/usuarios')) return 'users';
    if (path.includes('/roles')) return 'roles';
    if (path.includes('/permisos')) return 'permissions';
    if (path.includes('/configuracion/facturacion')) return 'invoicing';
    if (path.includes('/configuracion/ordenes')) return 'purchase-orders';
    if (path.includes('/configuracion/email')) return 'email';
    if (path.includes('/configuracion/sistema')) return 'system';
    if (path.includes('/configuracion')) return 'settings';
    return 'dashboard';
  }

  const tabs = [
    {
      id: 'users',
      label: 'Usuarios',
      icon: <FiUsers size={20} />,
      path: '/system/admin/usuarios',
      description: 'Gestión de usuarios del sistema'
    },
    {
      id: 'roles',
      label: 'Roles',
      icon: <FiShield size={20} />,
      path: '/system/admin/roles',
      description: 'Gestión de roles y permisos'
    },
    // Pestaña de Permisos oculta - la gestión de permisos se hace desde Roles
    // {
    //   id: 'permissions',
    //   label: 'Permisos',
    //   icon: <FiKey size={20} />,
    //   path: '/system/admin/permisos',
    //   description: 'Gestión de permisos del sistema'
    // },
    {
      id: 'settings',
      label: 'Configuración',
      icon: <FiSettings size={20} />,
      path: '/system/admin/configuracion',
      description: 'Configuraciones del sistema',
      hasSubmenu: true,
      submenu: [
        {
          id: 'invoicing',
          label: 'Facturación',
          icon: <FiFileText size={16} />,
          path: '/system/admin/configuracion/facturacion',
          description: 'Configurar series, numeración y formatos de facturas'
        },
        {
          id: 'purchase-orders',
          label: 'Órdenes de Compra',
          icon: <FiShoppingCart size={16} />,
          path: '/system/admin/configuracion/ordenes',
          description: 'Configurar órdenes de compra y proveedores'
        },
        {
          id: 'email',
          label: 'Email / SMTP',
          icon: <FiMail size={16} />,
          path: '/system/admin/configuracion/email',
          description: 'Configurar servidor SMTP y plantillas de email'
        },
        {
          id: 'system',
          label: 'Sistema General',
          icon: <FiSliders size={16} />,
          path: '/system/admin/configuracion/sistema',
          description: 'Configuraciones generales del sistema'
        }
      ]
    }
  ];

  const handleTabClick = (tab) => {
    setActiveTab(tab.id);
    navigate(tab.path);
  };

  const currentTab = tabs.find(t => t.id === activeTab);
  const showSubmenu = currentTab?.hasSubmenu && currentTab.id === activeTab;

  return (
    <div className="admin-container">
      {/* Header con colores corporativos */}
      <div className="admin-header">
        <button
          className="btn btn--ghost header-back"
          onClick={() => navigate('/system')}
        >
          <FiArrowLeft size={20} />
          <span style={{ marginLeft: '8px' }}>Volver</span>
        </button>

        <div style={{ flex: 1 }}>
          <h1 className="admin-title">
            <FiSettings size={32} />
            ADMINISTRACIÓN DEL SISTEMA
          </h1>
          <p className="admin-subtitle">
            Gestión de usuarios, roles, permisos y configuraciones del sistema Betel Natural
          </p>
        </div>
      </div>

      {/* Tabs de navegación */}
      <div className="admin-tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`admin-tab ${activeTab === tab.id || (tab.submenu && tab.submenu.some(s => s.id === activeTab)) ? 'admin-tab--active' : ''}`}
            onClick={() => handleTabClick(tab)}
          >
            <span style={{ fontSize: '20px' }}>{tab.icon}</span>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Submenu para Configuración */}
      {showSubmenu && currentTab.submenu && (
        <div className="admin-submenu">
          {currentTab.submenu.map(item => (
            <button
              key={item.id}
              className={`submenu-item ${activeTab === item.id ? 'submenu-item--active' : ''}`}
              onClick={() => {
                setActiveTab(item.id);
                navigate(item.path);
              }}
            >
              <span style={{ fontSize: '18px' }}>{item.icon}</span>
              <span>{item.label}</span>
            </button>
          ))}
        </div>
      )}

      {/* Contenido */}
      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
};

export default Admin;
